import { render, staticRenderFns } from "./LegacyGenericService.vue?vue&type=template&id=604dd38b&"
import script from "./LegacyGenericService.vue?vue&type=script&lang=js&"
export * from "./LegacyGenericService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports